import { Radio, RadioGroupField, TextField } from '@aws-amplify/ui-react';
import { useEffect, useState } from 'react';

interface ExportRangeSelectorProps {
  estimatedCount: number;
  rangeFrom?: number | null;
  rangeTo?: number | null;
  onChange: (range: { rangeFrom?: number; rangeTo?: number }) => void;
  onValidChange?: (isValid: boolean) => void;
  disabled?: boolean;
}

export function ExportRangeSelector({
  estimatedCount,
  rangeFrom,
  rangeTo,
  onChange,
  onValidChange,
  disabled
}: ExportRangeSelectorProps) {
  const hasExistingRange = rangeFrom != null && rangeTo != null;
  const [mode, setMode] = useState<'all' | 'range'>(hasExistingRange ? 'range' : 'all');
  const [from, setFrom] = useState<string>(rangeFrom?.toString() ?? '1');
  const [to, setTo] = useState<string>(rangeTo?.toString() ?? estimatedCount.toString());

  useEffect(() => {
    if (mode === 'all') {
      onChange({ rangeFrom: undefined, rangeTo: undefined });
      onValidChange?.(true);
    } else {
      const fromNum = parseInt(from, 10);
      const toNum = parseInt(to, 10);
      const isValid = !isNaN(fromNum) && !isNaN(toNum) &&
                      fromNum >= 1 && toNum >= 1 && fromNum <= toNum;
      onChange({
        rangeFrom: isNaN(fromNum) ? undefined : fromNum,
        rangeTo: isNaN(toNum) ? undefined : toNum
      });
      onValidChange?.(isValid);
    }
  }, [mode, from, to]);

  return (
    <div className="export-step__section">
      <h3 className="export-step__section-heading">Record Range</h3>
      <RadioGroupField
        legend=""
        name="exportRange"
        value={mode}
        onChange={(e) => setMode(e.target.value as 'all' | 'range')}
        isDisabled={disabled}
      >
        <Radio value="all">
          All records ({estimatedCount.toLocaleString()} total)
        </Radio>
        <Radio value="range">Specific range</Radio>
      </RadioGroupField>

      {mode === 'range' && (
        <div style={{ display: 'flex', gap: 15, marginTop: 15, marginLeft: 24 }}>
          <TextField
            label="From"
            type="number"
            value={from}
            onChange={(e) => setFrom(e.target.value)}
            size="small"
            width="120px"
            min={1}
            isDisabled={disabled}
          />
          <TextField
            label="To"
            type="number"
            value={to}
            onChange={(e) => setTo(e.target.value)}
            size="small"
            width="120px"
            min={1}
            isDisabled={disabled}
          />
        </div>
      )}
    </div>
  );
}
